/**
 * Shared utilities for AllTrafficChannelsOverviewBarChart components
 * Extracted to avoid circular dependencies
 */

/**
 * Sum all numeric values in an object
 */
export const sumObject = (obj: Record<string, any>): number => {
    let sum = 0;
    for (const el in obj) {
        if (obj.hasOwnProperty(el)) {
            sum += parseFloat(obj[el]);
        }
    }
    return sum;
};

/**
 * Get point Y value based on data format
 */
export const getPointY = (pointValue = 0, totalVisits: number, dataFormat: string): number => {
    const percentDataFormat = "%";

    switch (dataFormat) {
        case percentDataFormat:
            if (!totalVisits || totalVisits === 0) {
                return 0;
            } else {
                return 100 * (pointValue / totalVisits);
            }
        default:
            return pointValue;
    }
};
